import React from 'react';
import { clsx } from 'clsx';
import styles from './Button.module.css';

type ButtonVariant = 'primary' | 'secondary' | 'tertiary' | 'destructive' | 'ghost';
type ButtonSize = 'sm' | 'md' | 'lg';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  loading?: boolean;
  isLoading?: boolean;
  fullWidth?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  as?: React.ElementType;
}

export function Button({
  variant = 'primary',
  size = 'md',
  loading = false,
  isLoading = false,
  fullWidth = false,
  leftIcon,
  rightIcon,
  disabled,
  children,
  className,
  as: _as,
  ...props
}: ButtonProps) {
  void _as;
  const isActuallyLoading = loading || isLoading;
  return (
    <button
      {...props}
      disabled={disabled || isActuallyLoading}
      className={clsx(
        styles.button,
        styles[variant],
        styles[size],
        fullWidth && styles.fullWidth,
        isActuallyLoading && styles.loading,
        className,
      )}
    >
      {isActuallyLoading && <span className={styles.spinner} />}
      {!isActuallyLoading && leftIcon && <span className={styles.iconLeft}>{leftIcon}</span>}
      <span>{children}</span>
      {!isActuallyLoading && rightIcon && <span className={styles.iconRight}>{rightIcon}</span>}
    </button>
  );
}
